import { VerificationCode } from '@bz/account';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    dialog: {
      get title() {
        return t('Log in');
      },
      class: 'w-[500px] h-[690px] rounded-[2px]',
    },
  },
};

export default VerificationCode;
